import styled, { css } from 'styled-components'

import { color } from 'constants/cssConstants'

export const AppContainer = styled.div`
  /* @media screen and (min-width: 1439px) and (max-width: 1440px) {
    display: grid;
  } */
  height: 100vh;
  text-align: center;
`

export const MainRouteContainer = styled.main<{ isAuth?: boolean }>`
  /* width: calc(100vw - 54px); */
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  ${({ isAuth }) =>
    isAuth &&
    css`
      border-left: 0px solid ${color.black};
      border-right: 0px solid ${color.black};
      background: ${color.vistaWhite} 0% 0% no-repeat padding-box;
      margin-top: 50px;
      min-height: 100%;
    `}

  @media (max-width: 900px) {
    overflow: unset;
  }

  @media (max-width: 550px) {
    overflow: unset;
    width: unset;
    padding: 0;
  }

  @media (max-width: 208px) {
    width: 80%;
    margin: 0 auto;
  }
`
export const BrandSpinnerWrapper = styled.div<{ h?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ h }) => h ?? '100vh'} !important;
`
